<div [ngClass]="isDownloading ? 'hasLoader' : 'downloadContainer'">
  <div style="width: 100%;height: 100%;" *ngIf="!isDownloading">
    <div class="jumbotron" style="transform: translate(50%, 50%);width: 50%" *ngIf="!isDownloading && !src">
      <h1 class="display-4" style="position: relative;left: 25%">
      <span class="material-icons" style="color: #7000BD">
{{message === 'File Downloaded' ? 'done_outline' : 'error_outline'}}
</span>{{message}}</h1>
      <hr class="my-4">
      <button class="btn btn-primary homeBtn" (click)="navigateToHome()"><span class="k-i-home k-icon"
                                                                               style="bottom: 0.13em;"></span>Navigate
        to Home
      </button>
    </div>
    <ng2-pdfjs-viewer
      *ngIf="src"
      openFile="false"
      spread="false"
      [downloadFileName]="fileName"
      [pdfSrc]="src"
      [print]="isDesktop"
      scroll="false"
      #pdfViewerOnDemand
    ></ng2-pdfjs-viewer>
  </div>
  <app-tke-loader [isLoading]="isDownloading"></app-tke-loader>
</div>
